module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-02-en.630d4ed0ead45ed4905fb91ca7e5ad0c.png";